import { renderToString } from "react-dom/server";
import { getTexts } from "./texts";
import { parseDateString } from "../../util/date";
import {
  KlientkontoerklaeringFormValues,
  KlientkontoerklaeringMetadata,
} from "../../interfaces/klientkontoerklaering";

export default function HtmlResult(props: {
  values: KlientkontoerklaeringFormValues;
  metadata: KlientkontoerklaeringMetadata;
}) {
  const { values, metadata } = props;
  const texts = getTexts(values, metadata);
  return (
    <div className="as-document">
      <h1>{texts.formTitle}</h1>
      <p>
        <small>
          Tidspunkt: {new Date().toLocaleDateString("DA-dk")} kl.{" "}
          {new Date().toLocaleTimeString("DA-dk", {
            hour: "2-digit",
            minute: "2-digit",
          })}
        </small>
      </p>
      <section>
        <h2>1. {texts.advokatens_section_1.title}</h2>
        <h4>
          1.1{" "}
          {
            texts.advokatens_section_1
              .advokatens_section_1_1_samleklientbankkonti.title
          }
        </h4>
        {values.advokatens_section_1_1_samleklientbankkonti.length === 0 &&
          "Ingen konti opgivet"}
        {values.advokatens_section_1_1_samleklientbankkonti.length > 0 && (
          <table>
            <thead>
              <tr>
                <th></th>
                <th>Pengeinstitut</th>
                <th>Reg. kontonummer</th>
                <th>Opret dato</th>
                <th>CVR kontonr</th>
              </tr>
            </thead>
            <tbody>
              {values.advokatens_section_1_1_samleklientbankkonti.map(
                (konto, index) => (
                  <tr key={index}>
                    <th scope="row">{(index + 1).toString()}.</th>
                    <td>
                      {konto.pengeinstitution ? konto.pengeinstitution : "-"}
                    </td>
                    <td>{konto.regKontoNr ? konto.regKontoNr : "-"}</td>
                    <td>{konto.opretDato ? konto.opretDato : "-"}</td>
                    <td>{konto.cvrKonto ? konto.cvrKonto : "-"}</td>
                  </tr>
                ),
              )}
            </tbody>
          </table>
        )}
        <dl>
          <dt>
            1.2{" "}
            {
              texts.advokatens_section_1.advokatens_section_1_2_bogføringssystem
                .title
            }
          </dt>
          <dd>
            {texts.advokatens_section_1.advokatens_section_1_2_bogføringssystem.getAnswer()}
          </dd>
          <dt>
            1.3{" "}
            {
              texts.advokatens_section_1.advokatens_section_1_3_aabningsdag
                .title
            }
          </dt>
          <dd>
            {texts.advokatens_section_1.advokatens_section_1_3_aabningsdag.getAnswer()}
          </dd>
          <dt>
            1.4{" "}
            {
              texts.advokatens_section_1
                .advokatens_section_1_4_dispensation_ja_nej.title
            }
          </dt>
          <dd>
            {texts.advokatens_section_1.advokatens_section_1_4_dispensation_ja_nej.getAnswer()}
          </dd>
          {values.advokatens_section_1_4_dispensation_ja_nej === "Ja" && (
            <>
              <dt>
                {
                  texts.advokatens_section_1
                    .advokatens_section_1_5_dispensationDato.label
                }
              </dt>
              <dd>
                {texts.advokatens_section_1.advokatens_section_1_5_dispensationDato.getValue()}
              </dd>
              <dt>
                {
                  texts.advokatens_section_1
                    .advokatens_section_1_5_dispensationSagsnr.label
                }
              </dt>
              <dd>
                {texts.advokatens_section_1.advokatens_section_1_5_dispensationSagsnr.getValue()}
              </dd>
              <dt>
                {
                  texts.advokatens_section_1.advokatens_section_1_5_disp_periode
                    .label
                }
              </dt>
              <dd>
                {texts.advokatens_section_1.advokatens_section_1_5_disp_periode.getValue()}
              </dd>
              <dt>
                1.6{" "}
                {
                  texts.advokatens_section_1
                    .advokatens_section_1_6_bogføringAntalDage.title
                }
              </dt>
              <dd>
                {texts.advokatens_section_1.advokatens_section_1_6_bogføringAntalDage.getValue()}
              </dd>
            </>
          )}
        </dl>
      </section>
      <section>
        <h2>2. {texts.advokatens_section_2.title}</h2>
        <h3> {texts.advokatens_section_2.subtitle1}</h3>
        <dl>
          <dt>
            2.1{" "}
            {
              texts.advokatens_section_2
                .advokatens_section_2_1_samletKlienttilsvar_input.title
            }
          </dt>
          <dd>
            {texts.advokatens_section_2.advokatens_section_2_1_samletKlienttilsvar_input.getValue()}
          </dd>
          <dt>
            2.2{" "}
            {
              texts.advokatens_section_2
                .advokatens_section_2_2_indestaaende_input.title
            }
          </dt>
          <dd>
            {texts.advokatens_section_2.advokatens_section_2_2_indestaaende_input.getValue()}
          </dd>
          <dt>
            2.3{" "}
            {
              texts.advokatens_section_2.advokatens_section_2_3_differencen
                .title
            }
          </dt>
          <dd>
            {texts.advokatens_section_2.advokatens_section_2_3_differencen.getValue()}
          </dd>
        </dl>
        <h3> {texts.advokatens_section_2.subtitle2}</h3>

        <dl>
          {texts.advokatens_section_2.advokatens_section_2_3_differencen.getValue() !==
          "0,00 kr" ? (
            <>
              <dt>
                {texts.advokatens_section_2.advokatens_section_2_3_forMeget_forLidt.getValue()}
              </dt>
              <dd>
                {texts.advokatens_section_2.advokatens_section_2_3_forMegetellerLidtIndestaaende_input.getValue()}
              </dd>
              <dt>
                {texts.advokatens_section_2.advokatens_section_2_3_haevet_indsat.getValue()}
              </dt>
              <dd>
                {texts.advokatens_section_2.advokatens_section_2_3_haevet_indsat_dato.getValue()}
              </dd>
            </>
          ) : (
            <dd>
              {texts.advokatens_section_2.advokatens_section_2_3_ingen_regulering.getValue()}
            </dd>
          )}
        </dl>
      </section>
      <section>
        <h2>3. {texts.advokatens_section_3.title}</h2>
        <dl>
          <dt>
            3.1{" "}
            {
              texts.advokatens_section_3
                .advokatens_section_3_1_pengeinstitut_indestaende_input.title
            }
          </dt>
          <dd>
            {texts.advokatens_section_3.advokatens_section_3_1_pengeinstitut_indestaende_input.getValue()}
          </dd>
          <dt>
            3.2{" "}
            {
              texts.advokatens_section_3
                .advokatens_section_3_2_boghold_indestaende_beloeb.title
            }
          </dt>
          <dd>
            {texts.advokatens_section_3.advokatens_section_3_2_boghold_indestaende_beloeb.getValue()}
          </dd>
        </dl>
        <h4>3.3 {texts.advokatens_section_3.advokatens_section_3_3.title}</h4>
        <dl>
          <dt>
            a. {texts.advokatens_section_3.advokatens_section_3_3_a_input.title}
          </dt>
          <dd>
            {texts.advokatens_section_3.advokatens_section_3_3_a_input.getValue()}
          </dd>
          <dt>
            b. {texts.advokatens_section_3.advokatens_section_3_3_b_input.title}
          </dt>
          <dd>
            {texts.advokatens_section_3.advokatens_section_3_3_b_input.getValue()}
          </dd>
          <dt>
            c. {texts.advokatens_section_3.advokatens_section_3_3_c_input.title}
          </dt>
          <dd>
            {texts.advokatens_section_3.advokatens_section_3_3_c_input.getValue()}
          </dd>
          <dt>
            d. {texts.advokatens_section_3.advokatens_section_3_3_d_input.title}
          </dt>
          <dd>
            {texts.advokatens_section_3.advokatens_section_3_3_d_input.getValue()}
          </dd>
          <dt>
            e. {texts.advokatens_section_3.advokatens_section_3_3_e_input.title}
          </dt>
          <dd>
            {texts.advokatens_section_3.advokatens_section_3_3_e_beskrivelse.getValue()}
            :{" "}
            {texts.advokatens_section_3.advokatens_section_3_3_e_input.getValue()}
          </dd>
        </dl>
      </section>
      <section>
        <h2>{texts.revisors_header}</h2>
        <h3>{texts.revisors_formaal.header1}</h3>
        <h3>{texts.revisors_formaal.header2}</h3>
        <p>{texts.revisors_formaal.p1}</p>
        <p>{texts.revisors_formaal.p2}</p>
        <h3>{texts.revisors_advokatens_ansvar.header}</h3>
        <p>{texts.revisors_advokatens_ansvar.p1}</p>
        <p>{texts.revisors_advokatens_ansvar.p2}</p>
        <h3>{texts.revisors_revisors_ansvar.header}</h3>
        <p>{texts.revisors_revisors_ansvar.p1}</p>
        <p>{texts.revisors_revisors_ansvar.p2}</p>
        <p>{texts.revisors_revisors_ansvar.p3}</p>
        <h3>{texts.revisors_prof_etik.header}</h3>
        <p>{texts.revisors_prof_etik.p1}</p>
        <p>
          {texts.revisors_prof_etik.revisors_0_intro_overholder_revisorloven.getText()}
        </p>
        <p>{texts.revisors_prof_etik.p2}</p>
        <h3>{texts.revisors_arbhandlinger_og_observationer.header}</h3>
        <p>
          {texts.revisors_arbhandlinger_og_observationer.textBeforeDatepicker}{" "}
          <strong>
            {texts.revisors_arbhandlinger_og_observationer.getDatePickerText()}
          </strong>{" "}
          {texts.revisors_arbhandlinger_og_observationer.textAfterDatepicker}
        </p>
        <h2>{texts.revisors_handling_1.title}</h2>
        <p>{texts.revisors_handling_1.fieldset_legend}</p>
        <h3>{texts.revisors_handling_1.answer_heading}</h3>
        <p>
          {texts.revisors_handling_1.revisors_handling_1_question.getValue()}
        </p>
        <p>{texts.revisors_handling_1.getHandling1Alt2_3_4Text()}</p>
        <h2>{texts.revisors_handling_2.title}</h2>
        <div>{texts.revisors_handling_2.description}</div>
        <h3>{texts.revisors_handling_2.answer_heading}</h3>
        {texts.revisors_handling_2.revisors_handling_2_question.getAnswer()}
        <h2>{texts.revisors_handling_3.title}</h2>
        <p>{texts.revisors_handling_3.description}</p>
        <h3>{texts.revisors_handling_3.answer_heading}</h3>
        {texts.revisors_handling_3.revisors_handling_3_question.getAnswer()}
        <h2>{texts.revisors_handling_4.title}</h2>
        <p>{texts.revisors_handling_4.description}</p>
        <h3>{texts.revisors_handling_4.answer_heading}</h3>
        {texts.revisors_handling_4.revisors_handling_4_question.getAnswer()}
        <h2>{texts.revisors_handling_5.title}</h2>
        <p>{texts.revisors_handling_5.description}</p>
        <h3>{texts.revisors_handling_5.answer_heading}</h3>
        {texts.revisors_handling_5.revisors_handling_5_question.getAnswer()}
        <h2>{texts.revisors_handling_6.title}</h2>
        <p>{texts.revisors_handling_6.description}</p>
        <h3>{texts.revisors_handling_6.answer_heading}</h3>
        {texts.revisors_handling_6.revisors_handling_6_question.getAnswer()}
        <h2>{texts.revisors_handling_7.title}</h2>
        <p>{texts.revisors_handling_7.description}</p>
        <h3>{texts.revisors_handling_7.answer_heading}</h3>
        {texts.revisors_handling_7.revisors_handling_7_question.getAnswer()}
        <h2>{texts.revisors_handling_8.title}</h2>
        <p>{texts.revisors_handling_8.description}</p>
        <h3>{texts.revisors_handling_8.answer_heading}</h3>
        {texts.revisors_handling_8.revisors_handling_8_question.getAnswer()}
        <h2>{texts.revisors_handling_9.title}</h2>
        <p>{texts.revisors_handling_9.description}</p>
        <h3>{texts.revisors_handling_9.answer_heading}</h3>
        {texts.revisors_handling_9.getAnswer()}
        <h2>{texts.revisors_handling_10.title}</h2>
        <p>{texts.revisors_handling_10.description}</p>
        <h3>{texts.revisors_handling_10.answer_heading}</h3>
        {texts.revisors_handling_10.getAnswer()}
        <h2>{texts.revisors_handling_11.title}</h2>
        <p>{texts.revisors_handling_11.description}</p>
        <dl>
          <dt>
            {texts.revisors_handling_11.revisors_handling_11_periode.label}
          </dt>
          <dd>
            {texts.revisors_handling_11.revisors_handling_11_periode.getText()}
          </dd>
        </dl>
        <h3>{texts.revisors_handling_11.answer_heading}</h3>
        {texts.revisors_handling_11.getAnswer()}
        <h2>{texts.revisors_handling_12.title}</h2>
        <p>{texts.revisors_handling_12.description}</p>
        {values.revisors_handling_12_table.length === 0 &&
          "Ingen konti opgivet"}
        {values.revisors_handling_12_table.length > 0 && (
          <table>
            <thead>
              <tr>
                <th></th>
                <th>
                  {
                    texts.revisors_handling_12.revisors_handling_12_table
                      .revisors_handling_12_table_column_dato.label
                  }
                </th>
                <th>
                  {
                    texts.revisors_handling_12.revisors_handling_12_table
                      .revisors_handling_12_table_column_samlet_tilsvar_input
                      .label
                  }
                </th>
                <th>
                  {
                    texts.revisors_handling_12.revisors_handling_12_table
                      .revisors_handling_12_table_column_reguleringsbeloeb_input
                      .label
                  }
                </th>
                <th>
                  {
                    texts.revisors_handling_12.revisors_handling_12_table
                      .revisors_handling_12_table_column_reguleringsdato.label
                  }
                </th>
                <th>
                  {
                    texts.revisors_handling_12.revisors_handling_12_table
                      .revisors_handling_12_table_column_mellemvaerende_input
                      .label
                  }
                </th>
              </tr>
            </thead>
            <tbody>
              {values.revisors_handling_12_table.map((dag, index) => (
                <tr key={index}>
                  <th scope="row">{(index + 1).toString()}</th>
                  <td>
                    {dag.revisors_handling_12_table_columns_dato
                      ? parseDateString(
                          dag.revisors_handling_12_table_columns_dato,
                        )
                      : "-"}
                  </td>
                  <td>
                    {dag.revisors_handling_12_table_column_samlet_tilsvar_beloeb ??
                      "-"}
                  </td>
                  <td>
                    {texts.revisors_handling_12.revisors_handling_12_table.revisors_handling_12_table_column_reguleringsbeloeb_input.getValue(
                      dag.revisors_handling_12_table_column_reguleringsbeloeb_beloeb,
                      dag.revisors_handling_12_table_column_reguleringsbeloeb_plus_minus,
                    )}
                  </td>{" "}
                  <td>
                    {dag.revisors_handling_12_table_column_reguleringsdato
                      ? parseDateString(
                          dag.revisors_handling_12_table_column_reguleringsdato,
                        )
                      : "-"}
                  </td>
                  <td>
                    {dag.revisors_handling_12_table_column_mellemvaerende_beloeb ??
                      "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        <h3>{texts.revisors_handling_12.answer_heading}</h3>
        {texts.revisors_handling_12.getAnswer()}
        <h2>{texts.revisors_handling_13.title}</h2>
        <p>{texts.revisors_handling_13.description}</p>
        <h3>{texts.revisors_handling_13.answer_heading}</h3>
        <dl>
          <dt>
            {
              texts.revisors_handling_13
                .revisors_handling_13_antal_transaktioner_udvalgt_som_stikproeve
                .label
            }
          </dt>
          <dd>
            {values.revisors_handling_13_antal_transaktioner_udvalgt_som_stikproeve ??
              "-"}
          </dd>
        </dl>
        {!values.revisors_handling_13_question && (
          <p>
            <i>Svar mangler</i>
          </p>
        )}
        {values.revisors_handling_13_question ===
          texts.revisors_handling_13.revisors_handling_13_question
            .revisors_handling_13_question_alt_1.value && (
          <p>
            {
              texts.revisors_handling_13.revisors_handling_13_question
                .revisors_handling_13_question_alt_1.label
            }
          </p>
        )}
        {values.revisors_handling_13_question ===
          texts.revisors_handling_13.revisors_handling_13_question
            .revisors_handling_13_question_alt_2.value && (
          <>
            <p>
              {
                texts.revisors_handling_13.revisors_handling_13_question
                  .revisors_handling_13_question_alt_2.label
              }
            </p>
            <p>Uddybning:</p>
            <ol>
              {values.revisors_handling_13_question_alt_2_uddybning_table.map(
                (uddybning, i) => (
                  <li key={i}>
                    {/* <h4>{i + 1}
                  {"."}</h4> */}
                    <dl>
                      <div>
                        <dt>
                          <small>Dato</small>
                        </dt>
                        <dd>
                          {uddybning.revisors_handling_13_question_alt_2_uddybning_table_column_dato
                            ? parseDateString(
                                uddybning.revisors_handling_13_question_alt_2_uddybning_table_column_dato,
                              )
                            : "-"}
                        </dd>
                      </div>
                      <div>
                        <dt>
                          <small>Beløb</small>
                        </dt>
                        <dd>
                          {uddybning.revisors_handling_13_question_alt_2_uddybning_table_column_beloeb ??
                            "-"}
                        </dd>
                      </div>
                      <div>
                        <dt>
                          <small>Bilagsnummer</small>
                        </dt>
                        <dd>
                          {uddybning.revisors_handling_13_question_alt_2_uddybning_table_column_bilagsnummer ??
                            "-"}
                        </dd>
                      </div>
                      <div>
                        <dt>
                          <small>Begrundelse</small>
                        </dt>
                        <dd>
                          {uddybning.revisors_handling_13_question_alt_2_uddybning_table_column_begrundelse ??
                            "-"}
                        </dd>
                      </div>
                    </dl>
                  </li>
                ),
              )}
            </ol>
          </>
        )}
        <h2>{texts.revisors_handling_14.title}</h2>
        <p>{texts.revisors_handling_14.description}</p>
        <h3>{texts.revisors_handling_14.answer_heading}</h3>
        {texts.revisors_handling_14.getAnswer()}
        <h2>{texts.revisors_handling_15.title}</h2>
        <p>{texts.revisors_handling_15.description}</p>
        <h3>{texts.revisors_handling_15.answer_heading}</h3>
        {texts.revisors_handling_15.getAnswer()}
        <h2>{texts.revisors_handling_16.title}</h2>
        <p>{texts.revisors_handling_16.description}</p>
        <h3>{texts.revisors_handling_16.answer_heading}</h3>
        <dl>
          <dt>
            {
              texts.revisors_handling_16
                .revisors_handling_16_antal_kreditnotaer_udvalgt_som_stikproeve
                .label
            }
          </dt>
          <dd>
            {values.revisors_handling_16_antal_kreditnotaer_udvalgt_som_stikproeve ??
              "-"}
          </dd>
        </dl>
        {!values.revisors_handling_16_question && (
          <p>
            <i>Svar mangler</i>
          </p>
        )}
        {values.revisors_handling_16_question ===
          texts.revisors_handling_16.revisors_handling_16_question
            .revisors_handling_16_question_alt_1.value && (
          <p>
            {
              texts.revisors_handling_16.revisors_handling_16_question
                .revisors_handling_16_question_alt_1.label
            }
          </p>
        )}
        {values.revisors_handling_16_question ===
          texts.revisors_handling_16.revisors_handling_16_question
            .revisors_handling_16_question_alt_2.value && (
          <>
            <p>
              {
                texts.revisors_handling_16.revisors_handling_16_question
                  .revisors_handling_16_question_alt_2.label
              }
            </p>
            <p>Uddybning:</p>
            <ol>
              {values.revisors_handling_16_question_alt_2_uddybning_table.map(
                (uddybning, i) => (
                  <li key={i}>
                    {/* <h4>
                      {i + 1}
                      {"."}
                    </h4> */}
                    <dl>
                      <div>
                        <dt>
                          <small>
                            {
                              texts.revisors_handling_16
                                .revisors_handling_16_question_alt_2_uddybning_table
                                .revisors_handling_16_question_alt_2_uddybning_table_column_fakturanr
                                .label
                            }
                          </small>
                        </dt>
                        <dd>
                          {uddybning.revisors_handling_16_question_alt_2_uddybning_table_column_fakturanr
                            ? uddybning.revisors_handling_16_question_alt_2_uddybning_table_column_fakturanr
                            : "-"}
                        </dd>
                      </div>
                      <div>
                        <dt>
                          <small>
                            {
                              texts.revisors_handling_16
                                .revisors_handling_16_question_alt_2_uddybning_table
                                .revisors_handling_16_question_alt_2_uddybning_table_column_fakturadato
                                .label
                            }
                          </small>
                        </dt>
                        <dd>
                          {uddybning.revisors_handling_16_question_alt_2_uddybning_table_column_fakturadato
                            ? parseDateString(
                                uddybning.revisors_handling_16_question_alt_2_uddybning_table_column_fakturadato,
                              )
                            : "-"}
                        </dd>
                      </div>
                      <div>
                        <dt>
                          <small>
                            {
                              texts.revisors_handling_16
                                .revisors_handling_16_question_alt_2_uddybning_table
                                .revisors_handling_16_question_alt_2_uddybning_table_column_fakturabeloeb
                                .label
                            }
                          </small>
                        </dt>
                        <dd>
                          {uddybning.revisors_handling_16_question_alt_2_uddybning_table_column_fakturabeloeb
                            ? uddybning.revisors_handling_16_question_alt_2_uddybning_table_column_fakturabeloeb
                            : "-"}
                        </dd>
                      </div>
                      <div>
                        <dt>
                          <small>
                            {
                              texts.revisors_handling_16
                                .revisors_handling_16_question_alt_2_uddybning_table
                                .revisors_handling_16_question_alt_2_uddybning_table_column_modtager_navn_cvr
                                .label
                            }
                          </small>
                        </dt>
                        <dd>
                          {uddybning.revisors_handling_16_question_alt_2_uddybning_table_column_modtager_navn_cvr
                            ? uddybning.revisors_handling_16_question_alt_2_uddybning_table_column_modtager_navn_cvr
                            : "-"}
                        </dd>
                      </div>
                      <div>
                        <dt>
                          <small>
                            {
                              texts.revisors_handling_16
                                .revisors_handling_16_question_alt_2_uddybning_table
                                .revisors_handling_16_question_alt_2_uddybning_table_column_kreditnota_nr
                                .label
                            }
                          </small>
                        </dt>
                        <dd>
                          {uddybning.revisors_handling_16_question_alt_2_uddybning_table_column_kreditnota_nr
                            ? uddybning.revisors_handling_16_question_alt_2_uddybning_table_column_kreditnota_nr
                            : "-"}
                        </dd>
                      </div>
                      <div>
                        <dt>
                          <small>
                            {
                              texts.revisors_handling_16
                                .revisors_handling_16_question_alt_2_uddybning_table
                                .revisors_handling_16_question_alt_2_uddybning_table_column_kreditnota_dato
                                .label
                            }
                          </small>
                        </dt>
                        <dd>
                          {uddybning.revisors_handling_16_question_alt_2_uddybning_table_column_kreditnota_dato
                            ? parseDateString(
                                uddybning.revisors_handling_16_question_alt_2_uddybning_table_column_kreditnota_dato,
                              )
                            : "-"}
                        </dd>
                      </div>
                      <div>
                        <dt>
                          <small>
                            {
                              texts.revisors_handling_16
                                .revisors_handling_16_question_alt_2_uddybning_table
                                .revisors_handling_16_question_alt_2_uddybning_table_column_kreditnota_beloeb
                                .label
                            }
                          </small>
                        </dt>
                        <dd>
                          {uddybning.revisors_handling_16_question_alt_2_uddybning_table_column_kreditnota_beloeb
                            ? uddybning.revisors_handling_16_question_alt_2_uddybning_table_column_kreditnota_beloeb
                            : "-"}
                        </dd>
                      </div>
                      <div>
                        <dt>
                          <small>
                            {
                              texts.revisors_handling_16
                                .revisors_handling_16_question_alt_2_uddybning_table
                                .revisors_handling_16_question_alt_2_uddybning_table_column_kreditnota_begrundelse
                                .label
                            }
                          </small>
                        </dt>
                        <dd>
                          {uddybning.revisors_handling_16_question_alt_2_uddybning_table_column_kreditnota_begrundelse
                            ? uddybning.revisors_handling_16_question_alt_2_uddybning_table_column_kreditnota_begrundelse
                            : "-"}
                        </dd>
                      </div>
                      <div>
                        <dt>
                          <small>
                            {
                              texts.revisors_handling_16
                                .revisors_handling_16_question_alt_2_uddybning_table
                                .revisors_handling_16_question_alt_2_uddybning_table_column_ny_faktura_modtager_navn_cvr
                                .label
                            }
                          </small>
                        </dt>
                        <dd>
                          {uddybning.revisors_handling_16_question_alt_2_uddybning_table_column_ny_faktura_modtager_navn_cvr
                            ? uddybning.revisors_handling_16_question_alt_2_uddybning_table_column_ny_faktura_modtager_navn_cvr
                            : "-"}
                        </dd>
                      </div>
                      <div>
                        <dt>
                          <small>
                            {
                              texts.revisors_handling_16
                                .revisors_handling_16_question_alt_2_uddybning_table
                                .revisors_handling_16_question_alt_2_uddybning_table_column_ny_faktura_beloeb
                                .label
                            }
                          </small>
                        </dt>
                        <dd>
                          {uddybning.revisors_handling_16_question_alt_2_uddybning_table_column_ny_faktura_beloeb
                            ? uddybning.revisors_handling_16_question_alt_2_uddybning_table_column_ny_faktura_beloeb
                            : "-"}
                        </dd>
                      </div>
                    </dl>
                  </li>
                ),
              )}
            </ol>
          </>
        )}
        <h2>{texts.revisors_oevrige_oplysninger.title}</h2>
        <p>
          {
            texts.revisors_oevrige_oplysninger
              .revisors_oevrige_oplysninger_kundeforhold_accepteret_dato.label
          }{" "}
          {values.revisors_oevrige_oplysninger_kundeforhold_accepteret_dato ? (
            parseDateString(
              values.revisors_oevrige_oplysninger_kundeforhold_accepteret_dato,
            )
          ) : (
            <i>dd.mm.åååå</i>
          )}
        </p>
        <dl>
          <dt>{texts.revisors_oevrige_oplysninger.checkboxes_description}</dt>
          {values.revisors_oevrige_oplysninger_arbejsdomraade_checkbox_revision_af_aarsregnskab ? (
            <dd>
              {
                texts.revisors_oevrige_oplysninger
                  .revisors_oevrige_oplysninger_arbejsdomraade_checkbox_revision_af_aarsregnskab
                  .label
              }
            </dd>
          ) : (
            ""
          )}
          {values.revisors_oevrige_oplysninger_arbejsdomraade_checkbox_udvidet_gennemgang_af_aarsregnskab ? (
            <dd>
              {
                texts.revisors_oevrige_oplysninger
                  .revisors_oevrige_oplysninger_arbejsdomraade_checkbox_udvidet_gennemgang_af_aarsregnskab
                  .label
              }
            </dd>
          ) : (
            ""
          )}

          {values.revisors_oevrige_oplysninger_arbejsdomraade_checkbox_review_af_aarsregnskab ? (
            <dd>
              {
                texts.revisors_oevrige_oplysninger
                  .revisors_oevrige_oplysninger_arbejsdomraade_checkbox_review_af_aarsregnskab
                  .label
              }
            </dd>
          ) : (
            ""
          )}

          {values.revisors_oevrige_oplysninger_arbejsdomraade_checkbox_assistance_med_regnskabsopslilling_af_aarsregnskab ? (
            <dd>
              {
                texts.revisors_oevrige_oplysninger
                  .revisors_oevrige_oplysninger_arbejsdomraade_checkbox_assistance_med_regnskabsopslilling_af_aarsregnskab
                  .label
              }
            </dd>
          ) : (
            ""
          )}

          {values.revisors_oevrige_oplysninger_arbejsdomraade_checkbox_bogfoering ? (
            <dd>
              {
                texts.revisors_oevrige_oplysninger
                  .revisors_oevrige_oplysninger_arbejsdomraade_checkbox_bogfoering
                  .label
              }
            </dd>
          ) : (
            ""
          )}
        </dl>
        <dl>
          <dt>
            {
              texts.revisors_oevrige_oplysninger
                .revisors_oevrige_oplysninger_revisors_navn.label
            }
          </dt>
          <dd>{values.revisors_oevrige_oplysninger_revisors_navn ?? "-"}</dd>
          <dt>
            {
              texts.revisors_oevrige_oplysninger
                .revisors_oevrige_oplysninger_revisor_type.label
            }
          </dt>
          <dd>
            {values.revisors_oevrige_oplysninger_revisor_type ===
            texts.revisors_oevrige_oplysninger
              .revisors_oevrige_oplysninger_revisor_type
              .revisors_oevrige_oplysninger_revisor_type_option_statsautoriseret_revisor
              .id
              ? texts.revisors_oevrige_oplysninger
                  .revisors_oevrige_oplysninger_revisor_type
                  .revisors_oevrige_oplysninger_revisor_type_option_statsautoriseret_revisor
                  .label
              : values.revisors_oevrige_oplysninger_revisor_type ===
                  texts.revisors_oevrige_oplysninger
                    .revisors_oevrige_oplysninger_revisor_type
                    .revisors_oevrige_oplysninger_revisor_type_option_registreret_revisor
                    .id
                ? texts.revisors_oevrige_oplysninger
                    .revisors_oevrige_oplysninger_revisor_type
                    .revisors_oevrige_oplysninger_revisor_type_option_registreret_revisor
                    .label
                : "-"}
          </dd>
          <dt>
            {
              texts.revisors_oevrige_oplysninger
                .revisors_oevrige_oplysninger_firmanavn.label
            }
          </dt>
          <dd>{values.revisors_oevrige_oplysninger_firmanavn ?? "-"}</dd>
          <dt>
            {
              texts.revisors_oevrige_oplysninger
                .revisors_oevrige_oplysninger_cvrnr.label
            }
          </dt>
          <dd>{values.revisors_oevrige_oplysninger_cvrnr ?? "-"}</dd>
          <dt>
            {
              texts.revisors_oevrige_oplysninger
                .revisors_oevrige_oplysninger_adr_vej_husnr.label
            }
          </dt>
          <dd>
            {!values.revisors_oevrige_oplysninger_adr_vej_husnr &&
              !values.revisors_oevrige_oplysninger_adr_postnr_by &&
              "-"}
            {values.revisors_oevrige_oplysninger_adr_vej_husnr ?? ""}
            <br />
            {values.revisors_oevrige_oplysninger_adr_postnr_by ?? ""}
          </dd>
        </dl>
      </section>
    </div>
  );
}

export function getHtmlResult(
  values: KlientkontoerklaeringFormValues,
  metadata: KlientkontoerklaeringMetadata,
) {
  return renderToString(
    <HtmlResult values={values} metadata={metadata} />,
  ).replaceAll("<!-- -->", "");
}
